import GestaoOrcamentariaView from "../../components/gestaoOrcamentaria/GestaoOrcamentariaView";
import { getRoleFromToken } from "../../api";
import { DEPARTAMENTOS_CUSTOS_GERAIS, departamentosVisiveis } from "../../constants/departamentosOrcamento";

export default function CustosGerais() {
  const departamentos = departamentosVisiveis(getRoleFromToken()).filter((d) => DEPARTAMENTOS_CUSTOS_GERAIS.includes(d));
  return <GestaoOrcamentariaView tituloModulo="Custos Gerais" departamentos={departamentos} />;
}
